import { render, staticRenderFns } from "./PostAttachments.vue?vue&type=template&id=1240b712&scoped=true&"
import script from "./PostAttachments.vue?vue&type=script&lang=ts&"
export * from "./PostAttachments.vue?vue&type=script&lang=ts&"
import style0 from "./PostAttachments.vue?vue&type=style&index=0&id=1240b712&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1240b712",
  null
  
)

export default component.exports